import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

export const Wrapper = createComponent<
  ElementWithProps<{ isDefault?: boolean }>
>('div', ({ isDefault }) => ({
  className: cx(
    'flex w-full flex-col items-start gap-16 rounded-[6px] border border-solid border-grey-2 bg-white p-24 text-blue-6 min-[450px]:mx-auto min-[450px]:max-w-[680px]',
    {
      'min-[450px]:flex-row min-[450px]:items-center min-[450px]:justify-between':
        isDefault
    }
  )
}));

export const Title = createComponent<ElementWithProps<{ isDefault?: boolean }>>(
  'div',
  ({ isDefault }) => ({
    className: cx(' tl-header-m', {
      'min-[450px]:flex-1 min-[450px]:flex-shrink-0': isDefault
    })
  })
);
